// eslint-disable-next-line no-restricted-imports
import {
  Query_ClientController_GetDocumentGroup_Files_Items_Type as FileTypeApi1,
  Query_LegalClientController_GetAccountDocuments_Items_Type as FileTypeApi2,
} from 'api/generated/graphql';
import { FileEntity, FileTypeName } from 'api/types/entity';

type FileTypeApi = FileTypeApi1 | FileTypeApi2;

interface Args {
  id: string;
  name: string;
  size: number;
  type?: FileTypeApi;
  createdAt: Date;
}

export const parseFileEntity = (v: Args): FileEntity => ({
  id: v.id,
  name: v.name,
  size: v.size,
  type: v.type ? FileTypeName[v.type] : FileTypeName.Unknown,
  createdAt: new Date(v.createdAt),
});
